import { render, staticRenderFns } from "./ResellerInvoiceViewPayments.vue?vue&type=template&id=083ca175"
import script from "./ResellerInvoiceViewPayments.vue?vue&type=script&lang=js"
export * from "./ResellerInvoiceViewPayments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports